import axios from "axios";
import TokenHelper from "../helpers/TokenHelper";

const instance = axios.create({
  baseURL: `${window.API_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = TokenHelper.getLocalAccessToken();
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken.encodedToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // console.log(response.config.url);
    return response;
  },
  async (error) => {
    const originalConfig = error.config;
    // console.log(originalConfig.url);

    if ((originalConfig.url === "refresh-token" || 
        originalConfig.url === "/refresh-token") &&
        error.response && 
        error.response.status === 400) {
      // Refresh token was expired:
      // Some REST calls do not redirect to login screen 
      // on a timed out/invalid refresh token,
      // e.g. system translations or domains
      window.location.href = window.BASENAME_URL + "/login";
      return Promise.reject(error);

    } else if (originalConfig.url !== "login" && 
        originalConfig.url !== "/login" &&
        error.response) {
      // Access token was expired
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const refreshToken = TokenHelper.getLocalRefreshToken().encodedToken;
          // May be undefined after manual logout
          // and additional requests e.g. system translations
          if (refreshToken) {
            const response = await instance.post("/refresh-token", {
              refreshToken: refreshToken
           });
           const accessToken = response.data.token;
           TokenHelper.setLocalAccessToken(accessToken);
          }

          return instance(originalConfig);
        } catch (_error) {
          // Refresh token was expired, too
          TokenHelper.clearTokens();
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
